import IconWrapper, {
  IconWrapperProps,
} from "@repo/ui/src/components/IconWrapper";

interface KnifeIconProps extends IconWrapperProps {
  color?: string;
}

const KnifeIcon = ({ color, ...rest }: KnifeIconProps) => (
  <IconWrapper viewBox="0 0 32 32" width={32} {...rest}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M0,13 L32,13 C32,13 26.8,19.4 11.2,19.4 L11.2,15.8 L1.2,15.8 L0,13 Z"
        fill={color || "currentColor"}
      />
    </g>
  </IconWrapper>
);

export default KnifeIcon;
